var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-center tw-gap-2 tw-cursor-pointer"},[_c('v-icon',{staticClass:"tw-text-green",attrs:{"size":_vm.isPhone ? 18 : 20}},[_vm._v("mdi-circle-outline")]),_c('span',{staticClass:"tw-font-semibold tw-text-very-dark-gray",class:_vm.isPhone ? 'tw-text-base' : 'tw-text-lg'},[_vm._v(" "+_vm._s(_vm.brandText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }